import { useState, useEffect } from 'react'
import styled from '@emotion/styled'
import { throttle } from 'lodash-es'

const StickyScroll = styled.div`
  position: ${({ isSticky }) => (isSticky ? 'sticky' : 'relative')};
  top: ${({ isSticky }) => (isSticky ? '0' : 'unset')};
  z-index: 10;
  background-color: ${({ theme }) =>
    theme?.palette?.background?.default || 'white'};
  transform: ${({ isVisible }) =>
    isVisible ? 'translateY(0)' : 'translateY(-100%)'};
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
`

export const useStickyFilter = (scrollContainerId, threshold = 200) => {
  const [isVisible, setIsVisible] = useState(true) // 是否顯示
  const [isSticky, setIsSticky] = useState(false) // 是否啟用 sticky
  let lastScrollY = 0

  useEffect(() => {
    const scrollContainer = scrollContainerId
      ? document.getElementById(scrollContainerId)
      : window

    const handleScroll = () => {
      const currentScrollY = scrollContainerId
        ? scrollContainer.scrollTop
        : window.scrollY

      if (currentScrollY > threshold) {
        // 超過閾值啟用 sticky
        setIsSticky(true)

        if (currentScrollY < lastScrollY) {
          // 向上滾動：顯示
          setIsVisible(true)
        } else {
          // 向下滾動：隱藏
          setIsVisible(false)
        }
      } else {
        // 未超過閾值，關閉 sticky 並固定顯示
        setIsSticky(false)
        setIsVisible(true)
      }

      lastScrollY = currentScrollY
    }

    const throttledScroll = throttle(handleScroll, 100)

    scrollContainer.addEventListener('scroll', throttledScroll)
    return () => {
      scrollContainer.removeEventListener('scroll', throttledScroll)
      throttledScroll.cancel()
    }
  }, [scrollContainerId, threshold])

  return { StickyScroll, isSticky, isVisible }
}
